freespinSkipButton = {};

freespinSkipButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);

  button.canEnable = function () {
    return !button._flags.modal.active && freespins.canEnableSkip();
  };

  button.canShow = function () {
    return !button._flags.modal.active && freespins.canShowSkip();
  };

  return button;
};

freespinSkipButton.initialise = function (json, object) {};
freespinSkipButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "freespinSkipButton",
  freespinSkipButton.create,
  freespinSkipButton.initialise,
  freespinSkipButton.getFilesRequired
);
